(() => {
  setTimeout(() => {
    document.querySelector(".cart__checkout-wrapper").addEventListener("click", e => {
    if(!document.querySelector("#CartTerms").checked) {
        e.stopImmediatePropagation();
        e.preventDefault();
        e.stopPropagation();
        alert("You must agree with the terms and conditions of sales to check out")
    }
   }, true);
  }, 1200)
})()